export default __webpack_public_path__ + "static/media/drawing-woman7-focusfill.77d90b47.svg";